function deriveValuesFromState(schema) {
  return Object.keys(schema).reduce(
    (acc, key) => {
      acc[key] = schema[key].value;
      return acc;
    },
    {}
  );
}
export {
  deriveValuesFromState
};
//# sourceMappingURL=deriveValuesFromState.js.map
